import { isEmpty } from 'lodash';
import { ALL_EMPLOYERS_ID } from '../../../../utils/constants/employerNavigation';
import { getJobcaseEmployerAdminLevel } from '../../features/employers/selectors';
import entity from './entity';
import subOrgEntity from '../subOrganizations/entity';

const TYPES = {
  ...entity.TYPES,
};

export const getEmployersByName = (queryParams, fetchOptions = {}, ctx = {}) => async (dispatch, getState) => {
  const state = getState();
  const isJobcaseEmployerAdmin = getJobcaseEmployerAdminLevel(state);
  dispatch({ type: entity.TYPES.GET_REQUEST });

  try {
    const response = await entity.api.getOrganizationsByName(queryParams, fetchOptions, ctx);
    const data = {};
    const subOrgData = {};

    let filteredData = response?.data?.content || [];
    if (!isJobcaseEmployerAdmin) {
      filteredData = filteredData.filter(({ id }) => id !== ALL_EMPLOYERS_ID);
    }

    filteredData.forEach((emp) => {
      data[emp.id] = emp;

      if (!isEmpty(emp.sub_orgs)) {
        emp.sub_orgs.forEach((subOrg) => {
          subOrgData[subOrg.id] = subOrg;
        });
      }
    });
    dispatch({ type: entity.TYPES.GET_ALL_REQUEST_SUCCESS, payload: data });
    dispatch({ type: subOrgEntity.TYPES.GET_ALL_REQUEST_SUCCESS, payload: subOrgData });
    return { data: filteredData };
  } catch (error) {
    dispatch({ type: entity.TYPES.GET_ALL_REQUEST_ERROR, payload: error });
    throw error;
  }
};

export {
  TYPES,
};

export default {
  TYPES,
  ...entity.getActions(),
  getEmployersByName,
};
